import { render } from "./edit.vue?vue&type=template&id=5020bbe2&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=5020bbe2&lang=less"
import "./edit.vue?vue&type=style&index=1&id=5020bbe2&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5020bbe2"]])

export default __exports__